module.exports = __webpack_public_path__ + "static/mcsd-app-builder-certified-2016-d4f4a8f071cf4e68f7e30aba56f49feb.png";